import Vue from "vue";
import { is, isEmpty, isNil } from "ramda";

Vue.filter("cfStringBeautify", function (value) {
  if (!is(String) || isEmpty(value) || isNil(value)) return value;

  value = value.split("_").join(" ");
  return value.replace(/\b[a-z]/g, (f) => f.toUpperCase());
});
